import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types';
import Modal from './Modal';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative',
    backgroundColor: theme.palette.secondary.light,
    boxShadow: 'none',
    color: theme.palette.text.secondary
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1
  }
}));

function FullScreenModal({children, isOpened, onClose, title}) {
  const classes = useStyles();
  return (
    <Modal
      fullScreen
      Transition={Transition}
      isOpened={isOpened}
      onClose={onClose}
      disableEscapeKeyDown={false}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      disableEnforceFocus
    >
      <>
        <AppBar className={classes.appBar}>
          <Toolbar color="default">
            <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" component="h1" className={classes.title}>
              {title}
            </Typography>
          </Toolbar>
        </AppBar>
        <Box p={2}>{children}</Box>
      </>
    </Modal>
  );
}

FullScreenModal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.elementType, PropTypes.object]),
  isOpened: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  fullScreen: PropTypes.bool,
  withTransition: PropTypes.bool,
  title: PropTypes.string.isRequired
};

FullScreenModal.defaultProps = {
  onClose: null,
  fullScreen: false,
  withTransition: false
};

export default FullScreenModal;
